<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="mobile">
          <el-input class="login_ipt" v-model="ruleForm.mobile" :placeholder="$t('verify.PhoneNumber1')" @input="setInput()">
            <template  slot="prepend">
              <span>{{ruleForm.nationCode}}</span>
              <el-select class="login_flag"  v-model="ruleForm.nationCode" :placeholder="$t('SelectCountryRegion')" @change='changeLocation'>
                <el-option v-for="(item,index) in nationList" :key="index" :label="item.NationCode" :value="item.NationCode">
                  <div class="locationOption">
                    <img :src="item.IconUrl">
                    <span>{{$i18n.locale!='zh'?item.EnName:item.ChName}}</span>
                  </div>
                </el-option>
              </el-select>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" maxlength='20' :placeholder="$t('verify.Password')" @input="setInput()">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">{{$t('SignIn')}}</el-button>
        <div>
          <el-checkbox v-model='checked' :label="$t('RememberMe')" name="type">
            <i18n path="agreeTo" tag="div" class="userText"  >
              <router-link class="text_blue" :to="{path:'/useragreement'}" target="_blank">{{$t('UserAgreement')}}</router-link>
              <router-link class="text_blue" :to="{path:'/privacyagreement'}" target="_blank">{{$t('PrivacyPolicy')}}</router-link>
            </i18n>
          </el-checkbox>
        </div>
        <div class="tips">
          <div>
            <span @click="godialog('forgot','login')">{{$t('ResetPassword')}}</span>
            <el-divider direction="vertical"></el-divider>
            <span @click="godialog('register','login')">{{$t('SignUp')}}</span>
          </div>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { login,countries } from "@/api/public";
export default {
  name: 'login',
  components: {},
  data() {
    return {
      loading: false,
      dislogType: this.$enumInfo.dislogType,
      flagType: 'password',
      flag: false,
      checked: false,
      disabled: true,
      dialogClass: 'user',
      LocationIcon: null,
      nationList: '',
      ruleForm: {
        mobile: '',
        password: '',
        nationCode: '+86'
      },
      rules: {
        mobile: [
          { required: true, message: this.$t('verify.ValidPhoneNumber'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('verify.ValidPassword'), trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    that.getNationList()
    this.handleKeydown = (e) => {
      if (!this.disabled && e.keyCode === 13) {
        this.submitForm('ruleForm')
      }
    }
    window.addEventListener('keydown', this.handleKeydown)
    //console.log(this.$interface.SignIn)
  },
  beforeDestroy() {
    if (this.handleKeydown) {
      window.removeEventListener('keydown', this.handleKeydown)
    }
  },
  methods: {
    getNationList() {
      let that = this;
      let data = { PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetNationList, data).then(res => {
        if (res.Result != 0) {

          that.nationList = countries(res.Data) 
        }
      })
    },
    changeLocation(e) {
      let that = this
      that.nationList.map(res => {
        
        if (res.Code == e) {
          that.ruleForm.nationCode=res.NationCode
          //that.LocationIcon = res.IconUrl
        }
      })
    },
    // 点击快捷跳转 忘记密码 和 注册
    godialog(toval, val) {
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    closeOther(val, bol) {
      this.dislogType[val] = bol
    },
    // 关闭弹框
    closeDialog(val) {
      this.$emit('closeDialog', 'login', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      console.log(this.flag, this.flagType)
    },
    // 判断input是否有值
    setInput() {
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 登入
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          let data = that.ruleForm
          var Nation = that.ruleForm.nationCode
            if (Nation.indexOf('+') > -1) {
              Nation = Nation.slice(1)
              data.nationCode=Nation
            }
          if (that.checked) {
            that.loading = true;
            that.$post(that.$interface.SignIn, data).then(res => {
              if (res.Result != 0) {
                login(res.Data)
                that.closeDialog()
              } else {
                that.disabled = false
                that.$message.error(res.Msg);
              }
              that.loading = false;
            }).catch({})
          } else {
            that.$message.error(that.$t('verify.AgreeToTerms'));
            that.disabled = false
          }
          //login()
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";
/deep/ .login_flag input{
  width: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/login.vue